import React, { useState, useEffect } from "react";
import DynamicBanner from '../../include/DynamicBanner';
import api from '../../../../api';
import "./SafetySecurity.css";

const SafetySecurity = () => {
  const [safetyData, setSafetyData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatImage = (img) => {
    if (!img) return null;
    return `${process.env.REACT_APP_API_URL}/public/${img.replace(/^\//, "")}`;
  };

  useEffect(() => {
    const fetchSafetyData = async () => {
      try {
        const response = await api.get("/api/sitepages/academic/life-and-care");
        const data = response.data.data.safety;
        
        console.log("Safety API Data:", data); // For debugging

        // Format desktop banners
        const bannerImagesDesktop =
          data.banners?.desktop?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format mobile banners
        const bannerImagesMobile =
          data.banners?.mobile?.map(img =>
            img ? `/${img.replace(/^\//, "")}` : null
          ).filter(Boolean) || [];

        // Format sec3_items (safety features)
        const formattedFeatures = data.content?.sec3_items?.map(item => ({
          ...item,
          image: formatImage(item.image)
        })) || [];

        setSafetyData({
          ...data,
          bannerImagesDesktop,
          bannerImagesMobile,
          formattedFeatures
        });

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching Safety data:", err);
        setError("Failed to load Safety data");
        setIsLoading(false);
      }
    };

    fetchSafetyData();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center m-5">
        <h4>{error}</h4>
        <button 
          className="btn btn-primary mt-3"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
      </div>
    );
  }

  if (!safetyData) {
    return (
      <div className="text-center py-5">
        <h4>No safety data available.</h4>
      </div>
    );
  }

  const {
    title,
    bannerImagesDesktop,
    bannerImagesMobile,
    content,
    formattedFeatures
  } = safetyData;

  const { 
    sec2_heading = 'Safety & Security',
    sec2_description 
  } = content || {};

  return (
    <>
      {/* ---------------- BANNER ---------------- */}
      {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
        <DynamicBanner
          title={title}
          bgImage={bannerImagesDesktop}
          bgImageMobile={bannerImagesMobile}
        />
      )}

      <section className="safety-cards-section">
        <div className="container">
          <div className="sec-title text-center">
            <h2>{sec2_heading}</h2>
          </div>

          {/* Introduction Text */}
          {sec2_description && (
            <div className="safety-intro">
              <div dangerouslySetInnerHTML={{ __html: sec2_description }} />
            </div>
          )}

          {/* Safety Features Cards */}
          {formattedFeatures && formattedFeatures.length > 0 ? (
            <div className="row g-5 py-5">
              {formattedFeatures.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                  <div className="safety-card h-100">
                    {item.image && (
                      <div className="icon-wrapper">
                        <img 
                          src={item.image} 
                          alt={item.heading || `Safety feature ${index + 1}`} 
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                    {item.heading && (
                      <h5 className="mb-2 mt-2 mt-md-0">{item.heading}</h5>
                    )}
                    {item.description && (
                      <p>{item.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <h4>No safety features available at the moment.</h4>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SafetySecurity;